/**
 * Armazón del sitio web público: regla del espectro, menú (claro u oscuro), pie de marca
 * y el título/descripcion de cada página para buscadores y enlaces compartidos.
 */
import { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useIdiomaSitio, useT } from './idioma';
import './sitio.css';

export function useMeta(titulo) {
  const t = useT();
  const idioma = useIdiomaSitio(s => s.idioma);
  useEffect(() => {
    document.title = titulo;
    document.documentElement.lang = idioma;
    let d = document.querySelector('meta[name="description"]');
    if (!d) { d = document.createElement('meta'); d.setAttribute('name', 'description'); document.head.appendChild(d); }
    d.setAttribute('content', t.meta.descripcion);
  }, [titulo, idioma, t]);
}

export function SelectorIdioma() {
  const { idioma, cambiar } = useIdiomaSitio();
  const t = useT();
  return (
    <div className="idioma" role="group" aria-label={t.nav.idioma}>
      {['en', 'es'].map(i => (
        <button key={i} type="button" aria-pressed={idioma === i} onClick={() => cambiar(i)}>{i.toUpperCase()}</button>
      ))}
    </div>
  );
}

export function Navegacion({ tono = 'clara', estilo }) {
  const t = useT();
  const [abierta, setAbierta] = useState(false);
  const logo = tono === 'oscura' ? '/marca/f360-logo-blanco-2026.svg' : '/marca/f360-logo-color-2026.svg';
  return (
    <nav aria-label="Main" className={`nav caja ${tono}${abierta ? ' abierta' : ''}`} style={estilo}>
      <Link to="/" className="logo" aria-label="Finance 360"><img src={logo} alt="Finance360 by Kuanta Bridge" /></Link>
      <button type="button" className="hamburguesa" aria-expanded={abierta} aria-label={abierta ? t.nav.cerrar : t.nav.abrir} onClick={() => setAbierta(!abierta)}>
        {abierta ? <X size={22} /> : <Menu size={22} />}
      </button>
      <div className="enlaces">
        <NavLink to="/product">{t.nav.producto}</NavLink>
        <Link to="/#suite">{t.nav.suite}</Link>
        <NavLink to="/pricing">{t.nav.precios}</NavLink>
        <Link to="/#countries">{t.nav.paises}</Link>
        <NavLink to="/status">{t.nav.estado}</NavLink>
      </div>
      <div className="acciones">
        <SelectorIdioma />
        <Link to="/login" className="ingresar" style={{ fontSize: 15 }}>{t.nav.ingresar}</Link>
        <Link to="/demo" className="pildora primaria" style={{ minHeight: 44, padding: '0 22px', fontSize: 15 }}>{t.nav.demo}</Link>
      </div>
    </nav>
  );
}

export function Pie() {
  const t = useT();
  const l = t.pie.l;
  return (
    <footer className="pie" id="contact">
      <div className="caja dentro">
        <div className="fila">
          <div style={{ flex: '1 1 280px' }}>
            <img src="/marca/f360-logo-blanco-2026.svg" alt="Finance360 by Kuanta Bridge" />
            <p className="tag">{t.pie.tag}</p>
          </div>
          <div className="cols">
            <div className="col"><b>{t.pie.producto}</b><Link to="/product">{l.producto}</Link><Link to="/#ai">{l.ia}</Link><Link to="/#reports">{l.reportes}</Link><Link to="/pricing">{l.precios}</Link></div>
            <div className="col"><b>{t.pie.empresa}</b><a href="https://kuantabridge.com" target="_blank" rel="noreferrer">{l.kuanta}</a><Link to="/#suite">{l.suite}</Link><Link to="/demo">{l.demo}</Link></div>
            <div className="col"><b>{t.pie.legal}</b><span>{l.privacidad}</span><span>{l.terminos}</span></div>
          </div>
        </div>
        <div className="base">
          <span>{t.pie.derechos}</span>
          <span><Link to="/status">{l.estado}</Link> · info@kuantabridge.com</span>
        </div>
        <div className="cierre" />
      </div>
    </footer>
  );
}

/** Página del sitio: regla arriba, contenido, pie. El menú lo pone cada página (cambia de tono). */
export default function Marco({ children }) {
  return (
    <div className="f360-sitio">
      <div className="regla" />
      {children}
      <Pie />
    </div>
  );
}
